import { ErrorHandler, Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { fromRoot } from "../utilities/ngrx-loader.utility";
import { HttpErrorResponse } from "@angular/common/http";

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    constructor(
        private loaderStore: Store<{ loader: number }>,
    ) { }

    handleError(error: any) {
        if (error instanceof HttpErrorResponse) {
            this.loaderStore.dispatch(fromRoot.freeLoader()());
        }
    }
}